var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-inner sop-message-setting-form",
      staticStyle: { display: "flex", "flex-direction": "column" }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "margin-left": "-32px !important" }
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card", staticStyle: { "flex-grow": "1" } },
            [
              _c("div", { staticClass: "app-main-inner-row" }, [
                _c(
                  "div",
                  [
                    !_vm.readOnly
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.addSop }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                        )
                      : _vm._e(),
                    !_vm.readOnly
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "danger" },
                            on: { click: _vm.delSop }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "app-main-inner-row" },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", height: "200px" },
                    attrs: {
                      "show-side-bar": false,
                      "column-defs": _vm.sopGrid.columnDefs,
                      "row-data": _vm.sopGrid.rowData,
                      "grid-options": _vm.sopGrid.gridOptions
                    },
                    on: { gridReady: _vm.onSopReady }
                  })
                ],
                1
              ),
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.sopForm.hasOwnProperty("uuid"),
                      expression: "sopForm.hasOwnProperty('uuid')"
                    }
                  ],
                  ref: "trackingDetailForm",
                  staticStyle: { width: "100%" },
                  attrs: {
                    disabled: _vm.readOnly,
                    "label-position": "left",
                    "label-width": "90px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.PushTarget") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "300px" },
                          on: { change: _vm.refreshGrid },
                          model: {
                            value: _vm.sopForm.pushObject,
                            callback: function($$v) {
                              _vm.$set(_vm.sopForm, "pushObject", $$v)
                            },
                            expression: "sopForm.pushObject"
                          }
                        },
                        _vm._l(_vm.pushObjects, function(item) {
                          return _c("el-option", {
                            key: item.name,
                            attrs: { label: item.chineseName, value: item.name }
                          })
                        }),
                        1
                      ),
                      _vm.multipleTrigger
                        ? [
                            _c("el-checkbox", {
                              staticStyle: { "padding-left": "10px" },
                              attrs: {
                                label: _vm.$t(
                                  "SystemMaintenance.TriggerTypeChangePushMsg"
                                )
                              },
                              model: {
                                value: _vm.sopForm.valueChangePushMsg,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.sopForm,
                                    "valueChangePushMsg",
                                    $$v
                                  )
                                },
                                expression: "sopForm.valueChangePushMsg"
                              }
                            }),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t(
                                    "SystemMaintenance.AgainPushTitleDisplay"
                                  ),
                                  placement: "right"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-warning",
                                  staticStyle: {
                                    color: "#E6A23C",
                                    "font-size": "13px",
                                    padding: "0 5px"
                                  }
                                })
                              ]
                            )
                          ]
                        : _vm._e(),
                      !_vm.isEnterpriseWechat &&
                      _vm.sopForm.pushObject === "customer"
                        ? [
                            _c("el-checkbox", {
                              staticStyle: { "padding-left": "10px" },
                              attrs: {
                                label: _vm.$t(
                                  "SystemMaintenance.CheckBaseLabel"
                                )
                              },
                              model: {
                                value: _vm.sopForm.checkBase,
                                callback: function($$v) {
                                  _vm.$set(_vm.sopForm, "checkBase", $$v)
                                },
                                expression: "sopForm.checkBase"
                              }
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.PushChannel") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "300px" },
                          on: { change: _vm.refreshGrid },
                          model: {
                            value: _vm.sopForm.pushChannel,
                            callback: function($$v) {
                              _vm.$set(_vm.sopForm, "pushChannel", $$v)
                            },
                            expression: "sopForm.pushChannel"
                          }
                        },
                        _vm._l(_vm.pushChannels, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.name, value: item.value }
                          })
                        }),
                        1
                      ),
                      !_vm.isEnterpriseWechat &&
                      _vm.sopForm.pushObject !== "DesignatedPostsAndPersonnel"
                        ? _c("el-checkbox", {
                            staticStyle: { "padding-left": "10px" },
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_SendToEachRecipientSeparately"
                              )
                            },
                            model: {
                              value: _vm.sopForm.sendAlone,
                              callback: function($$v) {
                                _vm.$set(_vm.sopForm, "sendAlone", $$v)
                              },
                              expression: "sopForm.sendAlone"
                            }
                          })
                        : _vm._e(),
                      _c("el-checkbox", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              !_vm.isEnterpriseWechat &&
                              _vm.showSyncSendCCAddress,
                            expression:
                              "!isEnterpriseWechat && showSyncSendCCAddress"
                          }
                        ],
                        staticStyle: { "padding-left": "10px" },
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_SyncSendCCAddress")
                        },
                        model: {
                          value: _vm.sopForm.syncSendCCAddress,
                          callback: function($$v) {
                            _vm.$set(_vm.sopForm, "syncSendCCAddress", $$v)
                          },
                          expression: "sopForm.syncSendCCAddress"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isEnterpriseWechat,
                          expression: "!isEnterpriseWechat"
                        }
                      ],
                      attrs: { label: _vm.$t("SystemMaintenance.MailServer") }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: {
                                value: _vm.sopForm.mailServerType || "",
                                clearable: ""
                              },
                              on: { input: _vm.onMailServerTypeInput }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "SystemMaintenance.SystemEmail"
                                  ),
                                  value: 1
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "SystemMaintenance.CompanyEmail"
                                  ),
                                  value: 2
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "SystemMaintenance.PersonalEmail"
                                  ),
                                  value: 3
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.sopForm.mailServerType === 2 ||
                                    _vm.sopForm.mailServerType === 3,
                                  expression:
                                    "sopForm.mailServerType===2||sopForm.mailServerType===3"
                                }
                              ],
                              staticStyle: { "margin-left": "10px" }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning",
                                staticStyle: {
                                  color: "#E6A23C",
                                  "font-size": "14px",
                                  "margin-right": "5px",
                                  "line-height": "18px"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { "line-height": "18px" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.sopForm.mailServerType === 2
                                          ? _vm.$t(
                                              "SystemMaintenance.PushConfigServiceCompanyEmail"
                                            )
                                          : _vm.$t(
                                              "SystemMaintenance.PushConfigServicePersonalEmail"
                                            )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  !_vm.isEnterpriseWechat && _vm.sopForm.mailServerType === 3
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.SelectSendEmail")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.onSendEmailChange },
                                  model: {
                                    value: _vm.sopForm.sendEmail,
                                    callback: function($$v) {
                                      _vm.$set(_vm.sopForm, "sendEmail", $$v)
                                    },
                                    expression: "sopForm.sendEmail"
                                  }
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      staticStyle: {
                                        "margin-right": "10px",
                                        "line-height": "29px"
                                      },
                                      attrs: { label: 1 }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("CargoMsg.Cargo_Post"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-radio",
                                    {
                                      staticStyle: {
                                        "margin-right": "10px",
                                        "line-height": "29px"
                                      },
                                      attrs: { label: 2 }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SystemMaintenance.Assigner")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm.sopForm.sendEmail === 1
                                ? _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "162px" },
                                      model: {
                                        value: _vm.sopForm.position,
                                        callback: function($$v) {
                                          _vm.$set(_vm.sopForm, "position", $$v)
                                        },
                                        expression: "sopForm.position"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("CargoMsg.Cargo_Sales"),
                                          value: "sales"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("Message.Operation"),
                                          value: "op"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_CustomerService"
                                          ),
                                          value: "csr"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_CustomerServiceOverSea"
                                          ),
                                          value: "overseaOp"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_Documents"
                                          ),
                                          value: "doc"
                                        }
                                      }),
                                      _vm.lob === "SE" ||
                                      _vm.lob === "SI" ||
                                      _vm.lob === "IE"
                                        ? _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_AirlinePerson"
                                              ),
                                              value: "seaLine"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.lob === "AE" || _vm.lob === "AI"
                                        ? _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_AirlinePerson"
                                              ),
                                              value: "airline"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.lob === "RE" || _vm.lob === "RI"
                                        ? _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_AirlinePerson"
                                              ),
                                              value: "railwayLine"
                                            }
                                          })
                                        : _vm._e(),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("Clearing.CargoSales"),
                                          value: "salesOfGoods"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.FieldOperation"
                                          ),
                                          value: "siteOp"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_userDefinedRole1"
                                          ),
                                          value: "userDefinedRole1"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_userDefinedRole2"
                                          ),
                                          value: "userDefinedRole2"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.sopForm.sendEmail === 2
                                ? _c("cargo-advance-select", {
                                    staticStyle: { width: "162px" },
                                    attrs: {
                                      disabled: _vm.readOnly,
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_User,
                                      "method-params": {
                                        pageSize: 1000000,
                                        active: true,
                                        hasRole: true
                                      },
                                      "default-value":
                                        _vm.sopForm.assigner || "",
                                      filterable: ""
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.sopForm.assigner = p.value || 0
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.sopForm.pushChannel === 0 ||
                              _vm.isEnterpriseWechat,
                            expression:
                              "sopForm.pushChannel===0 || isEnterpriseWechat"
                          }
                        ]
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isEnterpriseWechat,
                                expression: "!isEnterpriseWechat"
                              }
                            ],
                            attrs: {
                              label: _vm.$t("SystemMaintenance.SubjectTemplate")
                            }
                          },
                          [
                            _c("el-input", {
                              ref: "themeTemplate",
                              on: {
                                focus: function($event) {
                                  _vm.eFocus = _vm.constant.eFocus.emailTitle
                                },
                                blur: _vm.blurEvent
                              },
                              model: {
                                value: _vm.templateTitle2Email,
                                callback: function($$v) {
                                  _vm.templateTitle2Email = $$v
                                },
                                expression: "templateTitle2Email"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { height: "230px" },
                            attrs: {
                              label: !_vm.isEnterpriseWechat
                                ? _vm.$t("SystemMaintenance.TextTemplate")
                                : _vm.$t("CargoMsg.Cargo_MessageContent")
                            }
                          },
                          [
                            _c("quill-editor", {
                              ref: "emailTextQuillEditor",
                              staticStyle: { height: "175px" },
                              attrs: {
                                disabled: _vm.readOnly,
                                options: _vm.editorOption
                              },
                              on: {
                                focus: function($event) {
                                  return _vm.onEditorFocus($event)
                                },
                                change: function($event) {
                                  return _vm.onEditorChange($event)
                                }
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.keyUp()
                                }
                              },
                              model: {
                                value: _vm.sopForm.templateText2Email,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.sopForm,
                                    "templateText2Email",
                                    $$v
                                  )
                                },
                                expression: "sopForm.templateText2Email"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SystemMaintenance.DataItem")
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "margin-bottom": "50px",
                                  width: "66%"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    ref: "dataItemTabDiv",
                                    staticClass: "outside"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { position: "relative" } },
                                      [
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.readOnly,
                                              expression: "readOnly"
                                            }
                                          ],
                                          staticClass: "mask"
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "outside-value",
                                            on: { click: _vm.spread }
                                          },
                                          [_vm._v(_vm._s(_vm.showName))]
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "el-icon-arrow-down icon",
                                          class: {
                                            rotatingShow: _vm.isShow,
                                            rotatingHide: !_vm.isShow
                                          }
                                        })
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.isShow,
                                            expression: "isShow"
                                          }
                                        ],
                                        staticClass: "operation"
                                      },
                                      _vm._l(_vm.dataItemTabs, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "item",
                                            class: {
                                              "set-color":
                                                _vm.value === item.code,
                                              "set-bgc": index === 0
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.selectItem(item)
                                              }
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.isZh
                                                    ? item.chineseName
                                                    : item.englishName
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.isShow && _vm.dataItems,
                                            expression: "isShow && dataItems"
                                          }
                                        ],
                                        staticClass: "dataItem"
                                      },
                                      _vm._l(_vm.dataItems, function(
                                        item,
                                        itemIndex
                                      ) {
                                        return _c(
                                          "span",
                                          {
                                            key: itemIndex,
                                            staticClass: "item",
                                            class: {
                                              itemChoose:
                                                _vm.chooseId === itemIndex
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.onClickSopDataItemByContent(
                                                  item.chineseName,
                                                  itemIndex
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(item.chineseName))]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                ),
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "300px" },
                                  attrs: {
                                    "static-options": _vm.dataItems,
                                    placeholder: _vm.$t(
                                      "CargoMsg.Cargo_SearchForTheDataYouWantToInsert"
                                    ),
                                    cache: false,
                                    filterable: "",
                                    "filter-type": "global",
                                    clearable: "",
                                    "tag-value": "chineseName",
                                    "default-value": _vm.dataItem
                                  },
                                  on: {
                                    parentCallBack: _vm.changeDataItem,
                                    focus: _vm.dataItemFocusEvent
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: !_vm.isEnterpriseWechat
                                ? _vm.$t("SystemMaintenance.AttachmentFileType")
                                : _vm.$t("CargoMsg.Cargo_PushFiles")
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.readOnly,
                                      expression: "readOnly"
                                    }
                                  ],
                                  staticStyle: { width: "300px" },
                                  attrs: { disabled: true },
                                  model: {
                                    value: _vm.currFileTypeNames,
                                    callback: function($$v) {
                                      _vm.currFileTypeNames = $$v
                                    },
                                    expression: "currFileTypeNames"
                                  }
                                }),
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.readOnly,
                                      expression: "!readOnly"
                                    }
                                  ],
                                  staticStyle: { width: "300px" },
                                  attrs: { readonly: "" },
                                  on: { focus: _vm.showFileTypeDialog },
                                  model: {
                                    value: _vm.currFileTypeNames,
                                    callback: function($$v) {
                                      _vm.currFileTypeNames = $$v
                                    },
                                    expression: "currFileTypeNames"
                                  }
                                }),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isEnterpriseWechat,
                                        expression: "isEnterpriseWechat"
                                      }
                                    ],
                                    staticStyle: { "margin-left": "10px" }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-warning",
                                      staticStyle: {
                                        color: "#E6A23C",
                                        "font-size": "14px",
                                        "margin-right": "5px",
                                        "line-height": "18px"
                                      }
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "line-height": "18px" }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_PushFilesTip"
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.sopForm.pushChannel === 1,
                            expression: "sopForm.pushChannel===1"
                          }
                        ]
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SystemMaintenance.TemplateSubject")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "300px" },
                                model: {
                                  value: _vm.sopForm.templateTheme,
                                  callback: function($$v) {
                                    _vm.$set(_vm.sopForm, "templateTheme", $$v)
                                  },
                                  expression: "sopForm.templateTheme"
                                }
                              },
                              _vm._l(_vm.templateThemes, function(item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label: item.chineseName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SystemMaintenance.TemplateContent")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: "",
                                type: "textarea",
                                rows: 5
                              },
                              on: {
                                focus: function($event) {
                                  _vm.eFocus = _vm.constant.eFocus.noteContent
                                }
                              },
                              model: {
                                value: _vm.sopForm.templateTitle2Note,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.sopForm,
                                    "templateTitle2Note",
                                    $$v
                                  )
                                },
                                expression: "sopForm.templateTitle2Note"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SystemMaintenance.TemplateExample")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 5,
                                disabled: ""
                              },
                              model: {
                                value: _vm.sopForm.templateText2Note,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.sopForm,
                                    "templateText2Note",
                                    $$v
                                  )
                                },
                                expression: "sopForm.templateText2Note"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ],
                2
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.sopForm.hasOwnProperty("uuid") &&
                        !_vm.isEnterpriseWechat,
                      expression:
                        "sopForm.hasOwnProperty('uuid') && !isEnterpriseWechat"
                    }
                  ],
                  staticClass: "app-main-inner-row",
                  staticStyle: {
                    "justify-content": "center",
                    "padding-top": "30px"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.showSendSopTest }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          !_vm.isEnterpriseWechat
                            ? _vm.$t("SystemMaintenance.SendTest")
                            : _vm.$t("CargoMsg.Cargo_Save")
                        )
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.sendSopTest.visible,
            title: _vm.$t("SystemMaintenance.SendTest"),
            width: "400px",
            "close-on-click-modal": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.sendSopTest, "visible", $event)
            }
          }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.$t("SystemMaintenance.SendTo")))]),
          _c("el-input", {
            staticStyle: { width: "200px" },
            model: {
              value: _vm.sendSopTest.target,
              callback: function($$v) {
                _vm.$set(_vm.sendSopTest, "target", $$v)
              },
              expression: "sendSopTest.target"
            }
          }),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.sendSopTestHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.sendSopTestCloseHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.fileTypeEditor.visible
        ? _c("mx-file-type-editor", {
            attrs: {
              visible: _vm.fileTypeEditor.visible,
              lob: _vm.lob,
              "file-id": _vm.fileTypeEditor.fileId,
              "file-category": _vm.fileTypeEditor.fileCategory
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.fileTypeEditor, "visible", $event)
              },
              saveFileType: _vm.onSaveFileType
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }